import Adicionar from './Adicionar';
import Editar from './Editar';

export const BancosAdicionar = Adicionar;
export const BancosEditar = Editar;
